import { PLAYER } from "../../../common/constants.ts";
import { DRAFT_ELIGIBLE_COUNTRIES } from "../../../common/constants.baseball.ts";
import { idb } from "../../db/index.ts";
import { g, helpers } from "../../util/index.ts";
import { player } from "../index.ts";

// Narrow repair for the old generator: immediate international free agents were
// assigned the future draft class's ratings year and disappeared from the FA UI.
// Only unsigned, undrafted players with one future row and no MLB history qualify.
// Never change age, raw ratings, contracts, signed players, or real draft prospects.
export const repairInternationalFreeAgents = async () => {
	const season = g.get("season");
	let repaired = 0;
	for (const p of await idb.cache.players.indexGetAll("playersByTid", PLAYER.FREE_AGENT)) {
		const rating = p.ratings[0];
		const age = season - p.born.year;
		if (p.real || p.stats.length > 0 || p.ratings.length !== 1 || !rating ||
			rating.season <= season || rating.season !== p.draft.year ||
			p.draft.round !== 0 || p.draft.pick !== 0 || p.draft.tid >= 0 ||
			age < 16 || age > 28 || DRAFT_ELIGIBLE_COUNTRIES.has(helpers.getCountry(p.born.loc))) continue;
		rating.season = season;
		p.draft.year = season;
		await player.updateValues(p);
		await idb.cache.players.put(p);
		repaired += 1;
	}
	return repaired;
};
